import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingSkeleton from 'components/feedback/LoadingSkeleton';
import {
  AdminAuthCallbackPage,
  AdminDashboardPage,
  AdminLoginPage,
  AppearancePage,
  CatalogSettingsPage,
  FeaturesPage,
  LayoutPage,
  NavigationPage,
} from 'pages';

const Lazy = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingSkeleton rows={3} />}>{children}</Suspense>
);

export const adminRoutes = {
  callback: <AdminAuthCallbackPage />,
  login: <AdminLoginPage />,
  protected: (
    <>
      <Route index element={<Lazy><AdminDashboardPage /></Lazy>} />
      <Route path="apariencia" element={<Lazy><AppearancePage /></Lazy>} />
      <Route path="layout" element={<Lazy><LayoutPage /></Lazy>} />
      <Route path="navegacion" element={<Lazy><NavigationPage /></Lazy>} />
      <Route path="catalogo" element={<Lazy><CatalogSettingsPage /></Lazy>} />
      <Route path="funcionalidades" element={<Lazy><FeaturesPage /></Lazy>} />
    </>
  ),
};
